import { render, staticRenderFns } from "./Timer.vue?vue&type=template&id=5f6c1f5a"
import script from "./Timer.vue?vue&type=script&lang=js"
export * from "./Timer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Countdown: require('/vercel/path0/components/partials/Countdown.vue').default,Button: require('/vercel/path0/components/common/Button.vue').default,Modal: require('/vercel/path0/components/common/Modal.vue').default})
